import { ProIp } from './ApiURL'

//http://192.168.29.113:8087/digital-library/cancelSubscripRoutes/deleteMembersCreation/mob
export const postCancelMembershipAPIURL =
  ProIp + 'cancelSubscripRoutes/deleteMembersCreation/mob'
